<template>
  <v-timeline-item
    v-if="conversion"
    color="leadActivity"
    icon="mdi-file-document-outline"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      accordion
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row
            no-gutters
            align="center"
            class="d-flex justify-center"
            :class="{'flex-column':$vuetify.breakpoint.smAndDown}"
          >
            <v-col md="8">
              <div class="mb-2 subtitle-1">
                Hat {{ title }} <strong v-if="conversion.download.postalShipping !== 'NONE'">per Post</strong> angefordert.
                <span v-if="conversion.download.postalShipping === 'AUTOMATIC'">Druck und Versand werden automatisch eingeleitet.</span>
                <span v-if="conversion.download.postalShipping === 'MANUAL'">Bitte versenden Sie das Dokument zeitnah.</span>
              </div>
              <div
                v-show="true"
                class="grey--text"
              >
                {{ landingpageName }}
              </div>
              <div v-if="conversion.postalShipping !== 'NONE'">
                <div
                  v-if="conversion.personalData.address"
                  class="grey--text"
                >
                  {{ conversion.personalData.address.street }} {{ conversion.personalData.address.houseNumber }} •
                  {{ conversion.personalData.address.zip }} {{ conversion.personalData.address.city }}
                </div>
              </div>
            </v-col>
            <v-col
              class="text-right grey--text pr-2"
              :class="{'text-start mt-2':$vuetify.breakpoint.smAndDown}"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col md="5">
              <v-list dense>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      Quelle:
                    </v-list-item-title>
                    <div class="grey--text text--darken-3 body-2">
                      {{ source }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="conversion.download.postalShipping !== 'NONE'"
                  class="px-0"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      Postalischer Versand:
                    </v-list-item-title>
                    <div class="grey--text text--darken-3 body-2">
                      {{ postalShipping(conversion.download.postalShipping) }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="5">
              <v-list dense>
                <v-list-item class="px-0">
                  <v-list-item-content>
                    <v-list-item-title>
                      Persönliche Angaben:
                    </v-list-item-title>
                    <div class="grey--text text--darken-3 body-2">
                      {{ name }}
                    </div>
                    <div class="grey--text text--darken-3 body-2">
                      {{ phone }}
                    </div>
                    <div
                      v-if="conversion.personalData.address"
                      class="grey--text text--darken-3 body-2"
                    >
                      <div>
                        {{ conversion.personalData.address.street }} {{ conversion.personalData.address.houseNumber }}
                      </div>
                      <div>
                        {{ conversion.personalData.address.zip }} {{ conversion.personalData.address.city }}
                      </div>
                      <div>
                        {{ country(conversion.personalData.address.country) }}
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <v-row v-if="conversion.download.postalShipping === 'MANUAL'">
            <v-col class="font-smaller">
              <strong>Unser Tipp:<br></strong>
              Schreiben Sie einen kurzen Vermerk ins Kommentarfeld, sobald Sie den Ratgeber versendet haben. So behalten Sie den Überblick.
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import CONVERSION from '../queries/Conversion.gql'
import { conversionSource } from '@/lib/conversionSource'

const POSTAL_SHIPPING_TYPES = {
  AUTOMATIC: 'Automatischer Versand',
  MANUAL: 'Manueller Versand',
  NONE: 'Kein Versand'
}

const COUNTRIES = {
  de: 'Deutschland',
  ch: 'Schweiz',
  at: 'Österreich'
}

export default {
  props: {
    data: { type: Object, default: null }
  },
  data () {
    return {
      conversion: null
    }
  },
  computed: {
    title () {
      if (!this.conversion) return
      return this.conversion.landingpage.type === 'CHECKLIST' ? 'eine Checkliste' : 'einen Ratgeber'
    },
    source () {
      if (!this.conversion) return
      return this.conversion.source || conversionSource[this.conversion.origin] || ''
    },
    landingpageName () {
      if (!this.conversion) return
      return this.conversion.landingpage.name
    },
    name () {
      if (!this.conversion) return
      if (!(this.conversion.personalData.firstname && this.conversion.personalData.lastname)) return ''
      return `${this.conversion.personalData.firstname} ${this.conversion.personalData.lastname}`
    },
    phone () {
      if (!this.conversion) return
      if (!this.conversion.personalData.formattedPhone) return ''
      return this.conversion.personalData.formattedPhone
    }
  },
  methods: {
    postalShipping (type) {
      return POSTAL_SHIPPING_TYPES[type]
    },
    country (value) {
      return COUNTRIES[value]
    }
  },
  apollo: {
    conversion: {
      query: CONVERSION,
      variables () {
        return {
          conversionId: this.data.details[this.data.type].conversionId
        }
      }
    }
  }
}
</script>

<style scoped>
.expansion-panels {
  margin: -24px -24px 0 -24px;
}
</style>
